// reducers.js

import {
  FETCH_ALTERNATIVE_PRODUCTS_REQUEST,
  FETCH_ALTERNATIVE_PRODUCTS_SUCCESS,
  FETCH_ALTERNATIVE_PRODUCTS_FAILURE,
  POST_ALTERNATIVE_PRODUCTS_REQUEST,
  POST_ALTERNATIVE_PRODUCTS_SUCCESS,
  POST_ALTERNATIVE_PRODUCTS_FAILURE,
} from '../actions/fetchAlternativeProductsAction';

const initialState = {
  data: null,
  mfrItemCodes: [],
  loading: false,
  error: null,
  postLoading: false,
  postError: null,
  postSuccessMessage: null,
};

const alternativeProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALTERNATIVE_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ALTERNATIVE_PRODUCTS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        mfrItemCodes: action.payload.data?.mfr_item_codes || [],
        loading: false,
        error: null,
      };
    case FETCH_ALTERNATIVE_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        mfrItemCodes: [],
        error: action.payload.error,
      };
    case POST_ALTERNATIVE_PRODUCTS_REQUEST:
      return {
        ...state,
        postLoading: true,
        postError: null,
        postSuccessMessage: null,
      };
    case POST_ALTERNATIVE_PRODUCTS_SUCCESS:
      return {
        ...state,
        postLoading: false,
        // If API returns updated codes under data.mfr_item_codes, reflect it
        mfrItemCodes: action.payload.data?.mfr_item_codes || state.mfrItemCodes,
        postSuccessMessage: action.payload.data?.message || 'Saved successfully',
      };
    case POST_ALTERNATIVE_PRODUCTS_FAILURE:
      return {
        ...state,
        postLoading: false,
        postError: action.payload.error,
      };
    default:
      return state;
  }
};

export default alternativeProductsReducer;

